(function(){
  'use strict';
  if(window.DaLucaAppleWidth)return;
  const key='daluca_apple_width';
  let width=new URLSearchParams(location.search).get(key)||'';
  if(!['22','24'].includes(width))width='';
  let queued=false;
  function text(node,value){if(node&&window.DaLucaI18n.sourceText(node)!==value)window.DaLucaI18n.setText(node, value);}
  function apply(){
    queued=false;
    const grid=document.getElementById('product-grid');
    if(!grid)return;
    const cards=Array.from(grid.querySelectorAll('product-card'));
    let shown=0;
    cards.forEach(card=>{
      const fits=!width||(card.dataset.dalucaAppleWidths||'').split(',').includes(width);
      const row=card.closest('li.column');
      if(row)row.hidden=!fits;
      if(fits)shown++;
    });
    document.querySelectorAll('[data-daluca-apple-width]').forEach(button=>{
      const active=button.dataset.dalucaAppleWidth===width;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
    document.querySelectorAll('#FacetFiltersForm').forEach(form=>{
      let carry=form.querySelector('input[name="'+key+'"]');
      if(width&&!carry){carry=document.createElement('input');carry.type='hidden';carry.name=key;form.append(carry);}
      if(carry){carry.value=width;carry.disabled=!width;}
    });
    {
      document.querySelectorAll('.thb-filter-count .facets__label,[data-daluca-product-count],.daluca-results-count,.daluca-filter-product-count').forEach(node=>text(node,shown+' products'));
      document.querySelectorAll('[data-daluca-mobile-view-results],.daluca-filter-drawer__done').forEach(node=>text(node,'VIEW '+shown+' PRODUCTS'));
    }
    const actions=document.querySelector('.daluca-filter-actions');
    let pill=document.querySelector('[data-daluca-apple-width-pill]');
    if(actions&&!pill){pill=document.createElement('button');pill.type='button';pill.dataset.dalucaAppleWidthPill='';pill.className='daluca-apple-width-pill';pill.addEventListener('click',()=>select(width));actions.append(pill);}
    if(pill){pill.hidden=!width;text(pill,width+'mm Apple Watch ×');pill.setAttribute('aria-label','Remove '+width+'mm Apple Watch filter');}
    let empty=document.querySelector('[data-daluca-apple-empty]');
    if(!empty){empty=document.createElement('p');empty.dataset.dalucaAppleEmpty='';empty.setAttribute('role','status');window.DaLucaI18n.setText(empty, 'No straps match these filters. Clear another filter to see more options in this Apple Watch size.');grid.after(empty);}
    empty.hidden=!width||shown>0;
  }
  function schedule(){if(!queued){queued=true;requestAnimationFrame(apply);}}
  function select(next){
    width=width===next?'':next;
    const url=new URL(location.href);
    width?url.searchParams.set(key,width):url.searchParams.delete(key);
    url.searchParams.delete('page');
    history.replaceState(null,'',url.pathname+url.search+url.hash);
    apply();
    document.dispatchEvent(new CustomEvent('daluca:apple-width-changed'));
  }
  window.DaLucaAppleWidth={selected:()=>width,select,refresh:schedule};
  function boot(){
    const root=document.querySelector('.collection-container');
    if(root)new MutationObserver(schedule).observe(root,{childList:true,subtree:true});
    document.addEventListener('click',event=>{if(event.target.closest('[data-daluca-clear-filters]')){width='';const url=new URL(location.href);url.searchParams.delete(key);history.replaceState(null,'',url.pathname+url.search+url.hash);schedule();}},true);
    window.addEventListener('popstate',()=>{width=new URLSearchParams(location.search).get(key)||'';schedule();});
    apply();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();

